<form #f="ngForm" [formGroup]="formSuscripcion" (ngSubmit)="onSubmit()" novalidate class="d-flex">
    <input type="email" class="form-control me-2" formControlName="email">
    <button type="submit" class="btn btn-primary">Suscribirme</button>
</form>